import { Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
    ApiFragment,
    FragmentId,
    Metadata,
    ShToastFactory,
    ZoneRestrictions,
    ZonesService
} from '@stylehaven/components';
import { RecordsService } from '../../common/services/api/records.service';
import { HttpService } from '../../common/services/http/http.service';
import { UserStoreService } from '../../common/services/user/user-store.service';
import { BaseSelectionService } from '../base-selection.service';

@Injectable({ providedIn: 'root' })
export class GenericSelectionService extends BaseSelectionService {
    private readonly genericSelectionsEndpoint: string = `v2/generic-selections`;

    constructor(
        protected recordsService: RecordsService,
        protected userStoreService: UserStoreService,
        protected zoneRestrictions: ZoneRestrictions,
        protected zoneService: ZonesService,
        protected toastFactory: ShToastFactory,
        protected translateService: TranslateService,
        private readonly http: HttpService
    ) {
        super(recordsService, userStoreService, zoneRestrictions, zoneService, toastFactory, translateService);
    }

    public getGenericSelection(recordId: string): Observable<ApiFragment> {
        const request = `${this.genericSelectionsEndpoint}/${recordId}`;

        return this.http.get<Metadata>(request).pipe(map(result => new ApiFragment(result)));
    }

    public createGenericSelection(records: readonly ApiFragment[]): Observable<ApiFragment> {
        const options: FragmentId[] = records.map(record => record.getFragmentId());
        return this.createGenericSelectionByIds(options);
    }

    public createGenericSelectionByIds(recordIds: FragmentId[]): Observable<ApiFragment> {
        const request: string = this.genericSelectionsEndpoint;

        return this.http.post<any>(request, { Records: recordIds }).pipe(map(result => new ApiFragment(result)));
    }
}
